export default __webpack_public_path__ + "static/media/Claridad Baja.fdaac0c5.svg";